{
  "common": {
    "loading": "Loading",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "learnMore": "Learn more",
    "edit": "Edit",
    "view": "View",
    "pleaseWait": "Please wait...",
    "done": "Done"
  },
  "billing-upgrade-cta-banner": {
    "billedTrialEnd": "You'll be billed <1>{{billedAmount}}</1> at the end of your trial. ",
    "completeBilling": "Add your billing details now to start your subscription. ",
    "planTrial": "You're on the {{plan}} trial. ",
    "remainingTrial": "You have <1>{{remaining}} remaining</1> on your {{plan}} plan trial. ",
    "startSubscription": "Start Subscription"
  },
  "calendar": {
    "common": {
      "title": "Calendar"
    }
  },
  "campaigns": {
    "common": {
      "title": "Campaigns",
      "tagTitle": "Tags",
      "createCampaign": "Create a Campaign",
      "createTag": "New Tag",
      "upgradePlan": "Upgrade Your Plan"
    },
    "campaignForm": {
      "cancel": "Cancel",
      "color": "Color",
      "createTitle": "Create Campaign",
      "createTagTitle": "New Tag",
      "editTitle": "Edit Campaign",
      "editTagTitle": "Edit Tag",
      "tagNameErrorText": "This {{entity}} already exists.",
      "tagLengthErrorText": "Name must be less than 100 characters.",
      "name": "Name",
      "tagNotice1": "Tags are visible to everyone in your organization. ",
      "notice1": "Campaign content is visible to everyone in your organization. ",
      "notice2": "Find out more",
      "notice3": " in our FAQ.",
      "placeholder": "Add campaign name",
      "tagPlaceholder": "For example: Quotes, Blog, Holidays...",
      "saveCampaign": "Save Campaign",
      "saveTag": "Save Tag"
    },
    "deleteCampaignModal": {
      "boldSubtext": "We won't be able to save or analyze any of your campaign data.",
      "cancel": "Cancel",
      "delete": "Yes, Delete Campaign",
      "loading": "Deleting...",
      "subtext": " If you also wish to stop the posts from within this campaign from publishing, please delete each one individually.",
      "title": "Are you sure you want to delete your campaign,"
    },
    "deleteTagModal": {
      "boldSubtext": "We won't be able to save or analyze any of your tag data.",
      "cancel": "Cancel",
      "delete": "Yes, Delete Tag",
      "loading": "Deleting...",
      "subtext": " If you also wish to stop the posts from within this tag from publishing, please delete each one individually.",
      "title": "Are you sure you want to delete your tag,"
    },
    "emptyState": {
      "createCampaign": "Create a Campaign",
      "imageTag": "Example of campaign with multiple posts scheduled.",
      "item1": "Build entire campaigns across channels.",
      "item2": "See how they fit together in your schedule.",
      "item3": "Review campaign performance and hit your goals.",
      "learnMore": "Learn More",
      "subtext": "Keep track of multichannel campaigns and create a healthy mix of content on social media.",
      "title": "Get a clearer picture of your social media strategy",
      "locked": "Your organization is currently on a plan that no longer supports team members, so these channels are locked and Campaigns are not available. Please contact {{email}} about upgrading the plan.",
      "permission": "It looks like your organization doesn't have any campaigns yet, and only admin users can create them. Request access from {{email}} or any other Admin.",
      "tagCreateHeading": "Organize your content",
      "tagCreateSubheading": "Use tags to organize, categorize, and track the success of different types of content."
    },
    "upgradePlanModal": {
      "title": "Upgrade to create more tags",
      "description": "You've reached the free plan limit of <strong>three tags</strong>. Unlock 250 tags and so much more by upgrading your plan.",
      "bullet1": "Schedule up to 2000 posts at a time.",
      "bullet2": "Advanced publishing and planning features.",
      "bullet3": "In-depth social analytics and reporting.",
      "button": "See Upgrade Options"
    },
    "viewCampaign": {
      "allPostsSent": {
        "createCampaign": "New Campaign",
        "createTag": "New Tag",
        "createPost": "New Post",
        "subtitle": "All the content scheduled for this campaign has been sent.",
        "tagSubtitle": "All the content scheduled with this tag has been sent.",
        "title": "Woohoo — everything sent!",
        "viewReport": "View Report"
      },
      "backToTags": "Back to tags",
      "createPost": "New Post",
      "deleteTag": "Delete Tag",
      "editTag": "Edit Tag",
      "deleteCampaign": "Delete Campaign",
      "editCampaign": "Edit Campaign",
      "emptyCampaignBanner": {
        "createPosts": "New Post",
        "learnMore": "Learn More",
        "subtext": "Eep, this campaign is empty! Create some posts and they'll be organized here for you to review.",
        "title": "Let's build your campaign",
        "tagSubtext": "Create some posts with this tag and they'll be organized here for you.",
        "tagTitle": "Let's create some content for this tag!"
      },
      "emptySentPosts": {
        "subtitle": "Once your scheduled posts are published, you'll see them here with some basic post analytics.",
        "title": "Standing by for sent posts..."
      },
      "emptyDrafts": {
        "subtitle": "But if you're feeling inspired...",
        "title": "There aren't any drafts for this campaign.",
        "tagTitle": "There aren't any drafts with this tag.",
        "createDraft": "New Draft"
      },
      "emptyApprovals": {
        "subtitle": "There aren't any drafts awaiting approval for this campaign.",
        "tagSubtitle": "There aren't any drafts awaiting approval with this tag.",
        "title": "You're all set!"
      },
      "emptyIdeas": {
        "title": "No ideas with this tag",
        "subtitle": "But if you're feeling inspired...",
        "createIdea": "New Idea"
      },
      "loadingCampaignDetails": "Loading campaign details such as date and counters, please hold on",
      "loadingTagDetails": "Loading tag details such as date and counters, please hold on",
      "loadingCampaignName": "Loading campaign name, please hold on",
      "loadingTagName": "Loading tag name, please hold on",
      "scheduled": "Scheduled",
      "scheduledTitle": "Scheduled",
      "sent": "Sent",
      "approvals": "Approvals",
      "drafts": "Drafts",
      "sentTitle": "Sent",
      "draftsTitle": "Drafts",
      "approvalsTitle": "Approvals",
      "viewCampaign": "View Campaign",
      "viewTag": "View Tag",
      "viewReport": "View Report",
      "ideas": "Ideas",
      "ideasTitle": "Ideas"
    },
    "limits": {
      "defaultMessage": "You've hit the {{tagsLimit}} tags limit.",
      "ctaMessage": "Upgrade to create more tags",
      "upgradeMessage": "Create up to {{tagsLimit}} tags on the Free plan.",
      "upgradePlan": "Upgrade Plan",
      "ctaLinkLabel": "Upgrade for unlimited."
    }
  },
  "content": {
    "editor": {
      "placeholder": {
        "0": "It all starts with an idea...",
        "1": "Everything begins with an idea...",
        "2": "Thinking... thinking...",
        "3": "Once upon a time...",
        "4": "Let it flow...",
        "5": "Starting is the hardest part...",
        "6": "Ready, set, flow...",
        "7": "Oh! I just thought of something...",
        "8": "What was that idea you had again?...",
        "9": "Wait... It's about to come to me...",
        "10": "It's time to brainstorm...",
        "11": "May the inspiration be with you..."
      }
    },
    "emptyIdeas": {
      "title": "A space to save your best ideas",
      "subtitle": "To start, click New Idea or drag and drop any images or videos. When you’re ready, turn that into a post!"
    },
    "common": {
      "title": "Content",
      "createIdea": "New Idea"
    },
    "dragAndDrop": {
      "dropTitle": "Drop up to 10 images or videos",
      "progress": "uploading 1 file",
      "progress_plural": "uploading {{count}} files"
    },
    "generation": {
      "errorGeneric": "Whoops! We are unable to generate content at this time. Please try again.",
      "errorTokens": "Whoops! Looks like you don't have any tokens left.",
      "requirements": "Add a text with at least {{limit}} words to use this feature",
      "longText": "AI-Assistant is only available for shorter text prompts",
      "tokensLeft": "Credits left",
      "label": "Generate",
      "aiAssistantLabel": "AI Assistant",
      "loadingLabel": "Generating...",
      "tryAgainLabel": "Try Again"
    },
    "upgradePath": {
      "empty": {
        "title": "Nice try!",
        "subtitle": "To create Ideas you'll need to update!",
        "button": "Update here"
      },
      "modal": {
        "title": "Unlock Ideas and more",
        "description": "You're on a <strong>legacy Buffer plan</strong>. Switch over to the newest version to unlock <0>Ideas</0>. With Ideas, you can capture and store your great ideas whenever they come to you. Plus you'll receive:",
        "bullet1": "Only pay for the channels you activate",
        "bullet2": "Unlimited team members (available on our team plan)",
        "bullet3": "Access to Analytics included on all plans",
        "bullet4": "Access to all new features guaranteed",
        "bullet5": "Access to our beta program",
        "bullet6": "Access to Twitter Threads",
        "button": "Find Out More"
      }
    },
    "modals": {
      "postSuccess": {
        "description": "Would you like to keep the original idea?",
        "discard": "Discard Idea",
        "keep": "Keep Idea"
      },
      "deleteConfirmation": {
        "title": "Delete idea",
        "description": "This can't be undone.",
        "confirm": "Delete",
        "cancel": "Cancel"
      },
      "confirmClose": {
        "title": "Discard any changes?",
        "description": "Any changes you've made will be lost. This can't be undone.",
        "confirm": "Discard Any Changes",
        "cancel": "Cancel"
      },
      "ideasLimitReached": {
        "paid": {
          "title": "You've hit the max amount of {{limit}} ideas",
          "description": "To create more ideas, delete some of your existing ones"
        },
        "free": {
          "title": "You've hit your limit of {{limit}} Ideas on the free plan",
          "description": "Upgrade your plan to unlock 2,000 Ideas plus...",
          "trial": {
            "listItem1": "Up to 2,000 scheduled posts",
            "listItem2": "Analytics on best times to post",
            "listItem3": "Engagement tools to answer comments",
            "button": "Start 14-day free trial",
            "buttonProcessing": "Processing...",
            "footer": "No credit card required"
          },
          "upgrade": {
            "listItem1": "Up to 2,000 scheduled posts",
            "listItem2": "Analytics on best times to post",
            "listItem3": "Engagement tools to answer comments",
            "button": "See Upgrade Options"
          }
        }
      },
      "integrations": {
        "searchButon": "Search",
        "noResults": "No results for that search",
        "tryAgain": "Try again with another word"
      }
    },
    "notifications": {
      "createIdea": {
        "successMessage": "Ok, we've created the idea!"
      },
      "updateIdea": {
        "successMessage": "Ok, we've updated the idea!"
      },
      "deleteIdea": {
        "successMessage": "Ok, we've deleted the idea!",
        "errorMessage": "Whoops, we couldn't delete the idea. Please try again."
      },
      "startTrial": {
        "successMessage": "Ok, we've started your trial!",
        "errorMessage": "Whoops, we couldn't start your trial. Please try again."
      },
      "keepIdea": {
        "successMessage": "Your original idea was saved.",
        "errorMessage": "Whoops, we couldn't save your original idea."
      },
      "discardIdea": {
        "successMessage": "Your idea was discarded",
        "errorMessage": "Whoops, we couldn't delete the idea."
      },
      "unsplash": {
        "errorMessage": "Whoops, we couldn't get the images from Unsplash. Please, try again later."
      }
    },
    "bar": {
      "onlyTenIdeasAllowed": "You can only add up to 10 images, videos or gifs to an idea"
    }
  },
  "default-page": {
    "connectButton": "Connect Your First Channel",
    "defaultTitle": "Let's get you connected and ready to go",
    "defaultDescription": "Our publishing tools work with Facebook, Instagram, Twitter, LinkedIn and Pinterest. Connect one today and begin publishing your posts!",
    "permissionTitle": "You've joined {{name}}, but something's missing...",
    "permissionSubtitle": "It looks like you haven't been given access to any of your organization's channels. Request access from {{email}} or any other Admin.",
    "permissionCta": "Learn More About Permissions"
  },
  "missing-access-page": {
    "heading": "This organization is missing access to our publishing tools",
    "altText": "A person publishing a post",
    "accessTypes": {
      "adminWithOrgAccess": {
        "description1": "Looks like your organization",
        "description2": "doesn't have access to our publishing tools quite yet. To add this, sign up below or switch to your other organization",
        "description3": "to gain access.",
        "secondaryLabel": "Sign Up",
        "primaryLabel": "Switch to"
      },
      "admin": {
        "description1": "Your organization",
        "description2": "has yet to sign up for our market leading publishing tools. Find out more or sign up today to get going!",
        "secondaryLabel": "Learn More",
        "primaryLabel": "Sign Up Today"
      },
      "nonAdminWithOrgAccess": {
        "description1": "Your organization",
        "description2": "has yet to sign up for our market leading publishing tools, but your other organization",
        "description3": "does.",
        "secondaryLabel": "Learn More",
        "primaryLabel": "Switch to"
      },
      "nonAdmin": {
        "description1": "Your organization",
        "description2": "doesn't have access to our publishing tools. The administrator can add this feature. If you can't reach them, for whatever reason, get in touch with us.",
        "secondaryLabel": "Contact Support"
      }
    }
  },
  "example": {
    "loggedIn": "Logged In...",
    "loggedOut": "Logged Out..."
  },
  "instagram-first-comment-modal": {
    "body": "We'll walk you through this now – It will just take a moment.",
    "canRequestMorePermission": "We'll open up a window for you to grant us that permission now.",
    "cancel": "Cancel",
    "continue": "Continue",
    "headline": "It looks like we'll need permission to post an Instagram comment on your behalf. ",
    "postOnYourBehalf": "You'll need to allow Buffer to automatically post Instagram comments on your behalf. ",
    "signout": "please sign out of your facebook account",
    "userNeedsLogoutSignin": "To do this, {signout}, and log into the account which corresponds with {profileName}. Then we can open up a window for you to grant us that permission by clicking continue."
  },
  "language": "Language",
  "plans-page": {
    "buttonDashboardText": "Back to Dashboard",
    "headerText": "Choose your Buffer Publish plan",
    "premium": {
      "billingText": "Billed Monthly",
      "buttonCurrentPlanText": "Current Plan",
      "buttonText": "Choose Plan",
      "cost": "$65",
      "featureTooltips": [
        "",
        "",
        "Plan, preview, and schedule Instagram Stories on web and mobile.",
        "Include the first comment when you schedule Instagram posts.",
        "Build a library of hashtag groups to use in Instagram first comments. Reuse top performers and optimize your reach.",
        "Add unique links to Instagram posts, turning your grid into a shoppable page via a static link in bio.",
        "Build entire campaigns across channels."
      ],
      "features": [
        "8 social channels",
        "2 users",
        "Instagram Stories",
        "Instagram first comment",
        "Hashtag Manager",
        "Shop Grid",
        "Campaigns",
        "Drafts and Approval Workflow"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$32.50",
      "plan": "premium_business",
      "soloCost": "$35",
      "soloNonProfitCost": "$17.50",
      "subtitle": "Unlock advanced IG features",
      "title": "Premium"
    },
    "premiumExperiment": {
      "billingText": "Billed Monthly",
      "buttonCurrentPlanText": "Current Plan",
      "buttonText": "Upgrade to Premium",
      "cost": "$65",
      "featureTooltips": [
        "",
        "Include the first comment when you schedule Instagram posts.",
        "Tag Instagram users when you schedule Instagram posts.",
        "Build a library of hashtag groups to use in Instagram first comments. Reuse top performers and optimize your reach.",
        "Add unique links to Instagram posts, turning your grid into a shoppable page via a static link in bio.",
        "Plan, preview, and schedule Instagram Stories on web and mobile.",
        "Build entire campaigns across channels."
      ],
      "features": [
        "8 social channels",
        "Instagram first comment",
        "Instagram user tagging",
        "Hashtag Manager",
        "Shop Grid",
        "Instagram Stories",
        "Campaigns",
        "Drafts and Approval Workflow"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$32.50",
      "plan": "premium_business",
      "soloCost": "$35",
      "soloNonProfitCost": "$17.50",
      "subtitle": "Unlock advanced IG features",
      "title": "Premium"
    },
    "pro": {
      "billingText": "Billed Monthly",
      "buttonCurrentPlanText": "Current Plan",
      "buttonText": "Choose Plan",
      "cost": "$15",
      "featureTooltips": [
        "",
        "",
        "Include first comment when you schedule Instagram posts.",
        "Build entire campaigns across channels."
      ],
      "features": [
        "8 social channels",
        "1 user",
        "Instagram first comment",
        "Campaigns"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$7.50",
      "plan": "pro",
      "subtitle": "Commit to a social strategy",
      "title": "Pro"
    },
    "proExperiment": {
      "billingText": "Billed Monthly",
      "buttonCurrentPlanText": "Current Plan",
      "buttonText": "Upgrade to Pro",
      "buttonTextDisabled": "Current Plan",
      "cost": "$15",
      "featureTooltips": [
        "",
        "Include first comment when you schedule Instagram posts.",
        "Tag Instagram users when you schedule Instagram posts.",
        "Build entire campaigns across channels."
      ],
      "features": [
        "8 social channels",
        "Instagram first comment",
        "Instagram user tagging",
        "Campaigns"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$7.50",
      "plan": "pro",
      "promoCost": "$10",
      "promoDiscount": "Discount applies for first 3 months",
      "promoNonProfitCost": "$5",
      "subtitle": "Commit to a social strategy",
      "title": "Pro"
    },
    "promoDescription": "For a limited time, upgrade to the Pro plan and keep your current pricing for 3 months.",
    "promoHeader": "Get more with the new Buffer Publish",
    "small": {
      "billingText": "Billed Monthly",
      "buttonCurrentPlanText": "Current Plan",
      "buttonText": "Choose Plan",
      "cost": "$99",
      "features": [
        "25 social channels",
        "6 users",
        "Instagram Stories",
        "Instagram first comment",
        "Hashtag Manager",
        "Shop Grid",
        "Campaigns",
        "Drafts and Approval Workflow"
      ],
      "monthly": "/mo",
      "nonProfitCost": "$49.50",
      "plan": "small",
      "subtitle": "Built for teams building brands",
      "title": "Business"
    }
  },
  "tabs": {
    "queue": "Queue",
    "stories": "Stories",
    "pastReminders": "Past Reminders",
    "pastStories": "Past Stories",
    "sentPosts": "Sent",
    "listView": "List View",
    "approvals": "Approvals",
    "drafts": "Drafts",
    "shopGrid": "Shop Grid",
    "settings": "Settings",
    "upgrade": "Upgrade",
    "posts": "Posts",
    "overview": "Overview",
    "general": "General",
    "postingSchedule": "Posting Schedule",
    "reconnecting": "Refreshing...",
    "reconnect": "Refresh"
  },
  "app-shell": {
    "preferences": "My Preferences",
    "team": "Team",
    "channels": "Channels",
    "upgrade": "Upgrade",
    "startProTrial": "Start Pro Trial",
    "upgradetoPro": "Upgrade to Pro",
    "helpCenter": "Visit Help Center",
    "quickHelp": "Quick Help",
    "status": "Status",
    "pricingAndPlans": "Pricing & Plans",
    "wishlist": "Wishlist"
  },
  "preferences": {
    "backToDashboard": "Back to Dashboard",
    "menu": {
      "appsAndExtras": "Apps & Extras",
      "billing": "Billing",
      "general": "General",
      "notifications": "Notifications",
      "security": "Security"
    },
    "general": {
      "title": "General",
      "changePreferences": "Change your general preferences.",
      "timeFormat": "Time Format",
      "hour": "hour",
      "dayToStartWeek": "Day to start the week",
      "sunday": "Sunday",
      "monday": "Monday"
    },
    "security": {
      "title": "Security",
      "addSecurity": "Add an extra layer of security to your account.",
      "password": "Password",
      "passwordDescription": "Use your password to sign in to Buffer on the web and mobile apps. Make it nice and secure!",
      "changeYourPassword": "Change Your Password",
      "twoFactorAuthentication": "Two Factor Authentication",
      "tfaExplanation": "Two factor authentication adds an extra layer of security for your Buffer account. Whenever you log in to your account, after entering your username and password, you will be asked for a second authentication code that will be sent to you via email or generated on an authentication app, such as Google Authenticator or Authy.",
      "method": "Method",
      "phoneNumber": "Phone number",
      "recoveryCode": "Recovery code",
      "sms": "SMS",
      "authenticatorApp": "Authenticator App",
      "enableTwoFactor": "Enable Two Factor Authentication",
      "changeTwoFactor": "Change Two Factor Authentication",
      "sendSecutiryCodes": "How would you like us to send your security codes?",
      "textMessage": "Text Message",
      "yourRecoveryCode": "Your Recovery Code",
      "saveOneTimeCode": "Save this one-time recovery code",
      "recoveryCodeDescription": "With Two Factor Authentication, if you lose your phone there's a possibility you could get locked out of your account. Save this code in a safe place to use if you can't log in with your phone."
    },
    "notifications": {
      "title": "Email Notifications",
      "description": "Get email alerts and updates to help you manage your Buffer account.",
      "collaboration": "Collaboration",
      "collaborationEmail": "Send me emails about contributions from team members. For example, if a post is awaiting approval.",
      "queue": "Queue Status Updates",
      "queueEmail": "Send me emails about changes to the status of my queue and scheduled posts. For example, when a post successfully publishes or if my queue becomes empty. ",
      "postFailure": "Post Failures",
      "postFailureEmail": "Send me an email if a post in my queue fails to be published.",
      "celebrations": "Celebrations",
      "celebrationsEmail": "Send me emails celebrating my social media achievements with Buffer.",
      "billing": "Billing",
      "billingEmail": "Send me emails relating to billing and payment reminders.",
      "productUpdatesAndNews": "Buffer Product Updates and News",
      "productUpdatesAndNewsEmail": "Send me occasional emails to help you get the most out of Buffer, including new feature and product announcements.",
      "newsletter": "Buffer's Social Media Weekly Newsletter",
      "newsletterEmail": "Send me Buffer's latest blog posts and curated advice to help you grow on social media.",
      "openBlogNewsletter": "Buffer's Open Blog Newsletter",
      "openBlogNewsletterEmail": "Our the blog posts on Buffer's open culture and our commitment to transparency.",
      "gettingStarted": "Getting Started with Buffer",
      "gettingStartedEmail": "Send me useful tips and best practices for getting the most out of Buffer.",
      "socialPostPromptsAndIdeas": "Social Post Prompts and Ideas",
      "socialPostPromptsAndIdeasEmail": "Send me daily inspiration and AI prompts for generating social media content.",
      "channelConnectionUpdates": "Channel Connection Updates",
      "channelConnectionUpdatesEmail": "Send me emails about your connected channels. For example, when a channel is disconnected.",
      "weeklyAnalyticsReport": "Weekly Post Recap",
      "weeklyAnalyticsReportEmail": "Send me a weekly report on the performance of your channels and posts.",
      "userFeedbackAndResearch": "User Feedback and Research",
      "userFeedbackAndResearchEmail": "Send me emails to participate in user feedback and research to help make Buffer better.",
      "bufferCareers": "Buffer Careers",
      "bufferCareersEmail": "Send me the latest career opportunities and role openings at Buffer."
    },
    "appsAndExtras": {
      "title": "Buffer Apps & Extras",
      "description": "Get the most out of Buffer with our mobile apps and browser extension.",
      "browserExtension": "Browser Extension",
      "extensionDescription": "Our browser extension lets you share content as you browse the web.",
      "installExtension": "Install the Browser extension",
      "mobileApps": "Mobile Apps",
      "mobileAppsDescription": "Share content and manage your Buffer account on the go with our mobile apps.",
      "viewOnAppleStore": "View on Apple Store",
      "viewOnGooglePlay": "View on Google Play",
      "connectedApps": "Connected Apps ",
      "connectedAppsDesc": "Get the most out of Buffer and share from your mobile, news reader, blog or anywhere! ",
      "getMoreApps": "Get More Apps →",
      "revokeAccess": "Revoke Access"
    }
  },
  "profile-sidebar": {
    "connectButton": "Manage Channels",
    "socialAccounts": "Channels",
    "queues": "Channels",
    "addChannels": "New Channel",
    "searchProfiles": "Search Channels",
    "noProfilesFound": "No Channels Found",
    "permissionSubtitle": "It looks like you haven't been given permission to add/manage channels. Request access from {{email}} or any other Admin."
  },
  "profiles-disconnected-banner": {
    "body": "Please make sure that you're logged into this account on the same network, and we'll get you back in business in no time!",
    "permissionBody": "Reach out to {{email}} or any other Admin.",
    "cta": "Refresh Channel",
    "extraMessage": {
      "instagram": "Due to recent changes to the Instagram API, your personal Instagram account will need to be refreshed."
    },
    "headline": "Uh-oh, we've lost access to this channel! Let's refresh."
  },
  "profiles-disconnected-modal": {
    "body1": "Refresh the connection to keep your posts on track.",
    "body1_plural": "Refresh the connections to keep your posts on track.",
    "cta": "Refresh",
    "extraMessage": {
      "instagram": "Due to recent changes to the Instagram API, your personal Instagram accounts will need to be refreshed."
    },
    "headline": "We're having trouble connecting to your channel",
    "headline_plural": "We're having trouble connecting to some of your channels",
    "reconnecting": "Please wait..."
  },
  "story-group-composer": {
    "addMedia": "Add Media",
    "addNote": "Add Note",
    "editNote": "Edit Note",
    "cancelNoteButton": "Back",
    "noteImageAlt": "Instagram story media",
    "notePlaceholder": "Add your caption or a note to self",
    "noteSubText": "When it comes time to post, you'll be able to copy and paste your note into Instagram.",
    "previewButton": "Preview",
    "processingVideo": "Processing video",
    "saveNoteButton": "Save Note",
    "scheduleButton": "Schedule Story",
    "scheduleLoadingButton": "Scheduling Story...",
    "shareNowButton": "Share Now"
  },
  "story-group-queue": {
    "bannerMobileTagText": "Looks like you might not have the latest version of the Buffer mobile app. Download it now to share this post.",
    "inputPlaceholder": "What would you like to add to your Story?",
    "mobileTagText": "Uh-oh! Looks like you might not have the latest version of the Buffer mobile app. Download it now to start using Stories!",
    "reminderLinkText2": "Reminder ",
    "reminderText1": "When it's time to post your Story, we'll send a ",
    "reminderText3": "to your mobile device.",
    "start": {
      "learnMore": "Learn More",
      "setReminders": "Set Up Reminders to Get Started",
      "step1Description": "Due to Instagram limitations, Stories can't be directly scheduled. A Reminder is a notification from the Buffer Publish app.",
      "step1Title": "Set Up Reminders",
      "step2Description": "Storyboard your content and create draft captions. Then, choose the date and time you'd like to share with your audience.",
      "step2Title": "Compose Your Story",
      "step3Description": "When your scheduled time arrives, Buffer will send you a Reminder. Preview on mobile, then tap to open in Instagram.",
      "step3Title": "Share Your Story",
      "title": "Get Started with Instagram Stories"
    }
  },
  "story-preview": {
    "addNote": "Add Note",
    "cancel": "Cancel",
    "editNote": "Edit Note",
    "noteExplanation": "When it comes time to post, you'll be able to copy and paste your note into Instagram.",
    "notePlaceholder": "Add your caption or a note-to-self",
    "noteTitle": "Note",
    "saveNote": "Save Note"
  },
  "remindersSetupWizard": {
    "headline": "Set Up Notifications",
    "setUpNotificationsButton": "Set Up Notifications",
    "testNotificationsButton": "Test Notifications",
    "description": "With Universal Publishing you can set up notifications from the Buffer mobile app to notify you when to publish your post.",
    "stepOne": {
      "headline": "Log in with the Buffer Mobile App",
      "description": "Use the Buffer account you are in now to see the same channels.",
      "ctaAndroid": "Get for Android",
      "ctaiOS": "Get for iOS",
      "buttonLabel": "Next"
    },
    "stepTwo": {
      "headline": "Enable Buffer App Notifications",
      "description": "📲 In the Buffer app, go to <b>Settings</b> and select <b>Account Settings</b>, then tap 'Enable Notifications'. If you don't see this button, notifications are already on!<br/><br/>⚠️ Ensure that Instagram has access to 'All Photos' on your phone's settings. <a href='https://support.buffer.com/articles/using-notification-publishing-gvZQiMxVa2?utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more' target='_blank' title='Learn more'>Learn more.</a>",
      "buttonLabel": "Test Notifications",
      "buttonLabelSending": "Sending...",
      "buttonLabelSent": "Sent",
      "buttonLabelTryAgain": "Try Again",
      "buttonLabelNotificationReceived": "I received the notification",
      "warningMessage": "Looks like you're having trouble receiving notifications from the Buffer app. <a href='https://support.buffer.com/articles/using-notification-publishing-gvZQiMxVa2?utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more' target='_blank' title='Check out this article for help'>Check out this article for help.</a>",
      "noDeviceFoundWarningMessage": "Looks like you haven't enabled mobile notifications for this account. Ensure you're signed into the right account on the app and try again."
    },
    "stepThree": {
      "headline": "Awesome! You’re ready for notifications \uD83D\uDE80",
      "description": "Here’s a quick rundown on how this works:",
      "itemListOne": "1. When creating a post in Buffer, choose the ‘Notify me’ option.",
      "itemListTwo": "2. We’ll send you a mobile notification when it’s time to post.",
      "itemListThree": "3. Tap the notification and we’ll take you to the social app. Images and videos are saved to your camera roll and text can be copied to your clipboard for easy access so you can finish and publish your post.",
      "buttonLabel": "Got It"
    }
  },
  "remindersBanner": {
    "headline": "Use native Instagram features in your posts",
    "description": "Create your post in Buffer and we'll send you a mobile notification when it's time to publish. You can then finish up your post in Instagram.",
    "linkText": "Learn more here."
  },
  "remindersGeneral": {
    "tooltip": "You'll receive a mobile notification to post yourself",
    "linkText": "Learn more",
    "hoverCardInfo": {
      "title": "Want to include trending music, mention users or add stickers to this post?",
      "text": "You'll get a notification on the Buffer mobile app when it's time to post so that you can add the finishing touches manually."
    }
  },
  "remindersSettings": {
    "title": "Enable Notifications by default",
    "description": "You can set up default notifications from the Buffer mobile app to notify you when to publish your posts for this channel.",
    "toggleLabel": {
      "on": "Enabled",
      "off": "Disabled"
    },
    "learnMore": "Learn more.",
    "notifications": {
      "enabled": "Notifications will be on by default for all content for this {{service}} account.",
      "disabled": "Notifications will be off by default, we'll post directly for you."
    },
    "notificationsOnlyChannels": {
      "title": "Notification-Based Publishing",
      "description": "You're currently on a {{profileType}} channel, and automatic publishing isn't supported by {{profileName}} for this type. Instead, Buffer will send you a notification to the Buffer mobile app when it's time to post, so you can publish yourself."
    }
  },
  "pinterestBanner": {
    "headlineInstagram": "Reach a whole new audience on the world's largest visual discovery engine.",
    "headlinePinterest": "Pinterest personal profiles are now supported in Buffer \uD83C\uDF89",
    "descriptionInstagram": "Pinterest personal profiles are now supported in Buffer. \uD83C\uDF89",
    "primaryLinkText": "Connect Now",
    "secondaryLinkText": "Read the Pinterest Guide"
  },
  "metaThreadsBanner": {
    "headline": "Threads is now available in Buffer",
    "description": "Learn more about the fastest growing social network and how to make it work for you.",
    "primaryLinkText": "Connect Threads",
    "secondaryLinkText": "Read our Beginner's Guide"
  },
  "blueskyBanner": {
    "headline": "Bluesky is now available in Buffer",
    "description": "Learn more about one of the fastest growing social networks and how to make it work for you.",
    "primaryLinkText": "Connect Bluesky",
    "secondaryLinkText": "Read our Beginner's Guide"
  },
  "tiktokImages": {
    "headline": "New! Schedule Images To TikTok",
    "description": "Connect your account to crosspost images to Instagram and TikTok.",
    "primaryLinkText": "Connect TikTok"
  },
  "twitterPremiumBanner": {
    "headline": "Schedule Up to 25000 Character Posts on X Premium",
    "description": "Update your legacy plan to take full advantage of an X Premium subscription.",
    "primaryLinkText": "See Upgrade Options"
  },
  "pastRemindersTab": {
    "header": "These posts were sent as Reminders and may still require posting."
  },
  "upload-zone": {
    "buttonTitle": "Upload media",
    "invalidFileSize": "We can't upload \"{fileName}\" because it's too large: we can only handle files of that type up to {formattedMaxSize}. Could you try a smaller file?",
    "tooSmallFileSize": "We can't upload \"{fileName}\" because it's too small. This channel can only handle files of that type from {formattedMinSize}. Could you try a bigger file?",
    "invalidFormatCantOneOfFiles": "We can't quite use some of the selected types of files. Could you try one of the following instead: {acceptedFilesText}",
    "invalidFormatCantSingleFile": "We can't quite use that type of file. Could you try one of the following instead: {acceptedFilesText}?",
    "invalidFormatCantUseAnyFiles": "We can't quite use any of the selected types of files. Could you try one of the following instead: {acceptedFilesText}",
    "invalidFormatCantUseSomeFiles": "We can't quite use some of the selected types of files. Could you try one of the following instead: {acceptedFilesText}"
  },
  "user-tags": {
    "btnCancel": "Cancel",
    "btnSave": "Save",
    "footerText": "Instagram API limitations prevent searching for usernames and tagging private users.",
    "imgAltText": "Image to tag users",
    "inputBtnAddTag": "Add Tag",
    "inputBtnCancel": "Cancel",
    "inputBtnLabel": "Add Tag",
    "inputLabel": "Instagram User",
    "maxLimitText": "Reached the 20 tag limit.",
    "placeholder": "username",
    "rightHeader": "Tag Users",
    "rightHeaderSubtext": "Click anywhere on the photo to tag a public user.",
    "tooltip": "View profile",
    "usernameError": "Oops! User already tagged"
  },
  "hashtag-manager-paywall": {
    "title": "Save Your Favorite Hashtags",
    "description": "Keep your hashtags handy and organized, so you can reuse them in seconds. You will also get:",
    "features": [
      "Unlimited post scheduling, threads, ideas and tags.",
      "Advanced analytics.",
      "Commenting tools."
    ],
    "buttonText": "See Upgrade Options"
  },
  "first-comment-paywall": {
    "title": "Upgrade your plan for more powerful and flexible scheduling options",
    "features": [
      "First comment scheduling",
      "No posting limits",
      "Hashtag management",
      "And much more!"
    ],
    "buttonText": "See Upgrade Options"
  }
}
